
























import { Component, Vue, Prop } from "vue-property-decorator";
import { logout } from "@/req/user";
@Component
export default class Logout extends Vue {
  @Prop({ default: {}, type: Object }) public payformline;
  public active = 0;
  public payList = [
    {
      type: 0,
      pay_name: "充值"
    },
    {
      type: 1,
      pay_name: "提现"
    },
    {
      type: 2,
      pay_name: "明细"
    }
  ];
  public payActive(index) {
    this.active = index;
    this.$emit("tabsSkip", index);
  }
}
